import { useEffect, useState } from "react";
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  Grid,
  IconButton,
  InputAdornment,
  FilledInput,
  FormControl,
  InputLabel,
} from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ClearIcon from "@mui/icons-material/Clear";
import "./CardInfoContent.scss";
import { PathParamModel } from "../../_models/PathParamModel";

interface PathInfoProps {
  pathinfo: PathParamModel[];
  handlePath?: (payload: { [label: string]: string }) => void;
}

export const PathInfoContent = ({ pathinfo, handlePath }: PathInfoProps) => {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(
    pathinfo.length > 0 ? pathinfo[0].id : null
  );

  const [inputValues, setInputValues] = useState<{
    [label: string]: string;
  }>({});

  useEffect(() => {
    const initialValues: { [label: string]: string } = {};
    pathinfo.forEach((param) => {
      initialValues[param.label] = param.value || "";
    });
    setInputValues(initialValues);
    setSelectedIndex(pathinfo.length > 0 ? pathinfo[0].id : null);
  }, [pathinfo]);

  useEffect(() => {
    if (handlePath) {
      handlePath(inputValues);
    }
  }, [inputValues, handlePath]);

  const handleChange = (label: string, value: string) => {
    setInputValues((prevInputValues) => ({
      ...prevInputValues,
      [label]: value,
    }));
  };

  const handleListItemClick = (id: number | null) => {
    setSelectedIndex(id);
  };

  const handleClear = (label: string) => {
    setInputValues((prevInputValues) => ({
      ...prevInputValues,
      [label]: "",
    }));
  };

  return (
    <div>
      <Accordion defaultExpanded className="accordian-content">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={{ m: 0 }}
          className="accordian-header"
          aria-controls="panel1bh-content"
        >
          Path
        </AccordionSummary>
        <AccordionDetails className="accordian-info">
          <Box>
            <List component="nav" aria-label="main mailbox folders">
              {pathinfo.map((header, index) => (
                <ListItem key={header.id + index} disablePadding>
                  <ListItemButton
                    className="list-info"
                    disableRipple
                    selected={selectedIndex === header.id}
                    onClick={() => handleListItemClick(header.id)}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={8}>
                        <div className="text-header-width">
                          <div className="header-txt">
                            {header.label}
                            <span className="required"> *</span>
                            <span className="string-info">String</span>
                          </div>
                          <div className="sub-content">
                            {header.info}
                            {""}
                            <span className="bold-txt">{header.infobold}</span>
                          </div>
                        </div>
                      </Grid>
                      <Grid
                        item
                        xs={4}
                        display="flex"
                        justifyContent="end"
                        className="custom-controllers"
                      >
                        <FormControl fullWidth variant="filled">
                          <InputLabel
                            htmlFor={`input-with-no-floating-label${header.id}`}
                          >
                            {header.label}
                          </InputLabel>
                          <FilledInput
                            id={`input-with-no-floating-label${header.id}`}
                            placeholder={`Enter ${header.placeholder}`}
                            value={inputValues[header.label] || ""}
                            onChange={(event) =>
                              handleChange(header.label, event.target.value)
                            }
                            autoComplete="off"
                            endAdornment={
                              inputValues[header.label] && (
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="clear input"
                                    onClick={() => handleClear(header.label)}
                                    edge="end"
                                  >
                                    <ClearIcon />
                                  </IconButton>
                                </InputAdornment>
                              )
                            }
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Box>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};
